import * as React from 'react';
import { createContext, useContext, useState, useCallback } from 'react';
import { DoctorsDrugsModal, DoctorsDrugsTab } from '../pages/plans/advanced/ui/doctors-drugs-modal';

// ─── Context ──────────────────────────────────────────────────────────────────

interface DoctorsDrugsModalCtx {
  openDoctorsDrugsModal: (tab?: DoctorsDrugsTab) => void;
}

const Ctx = createContext<DoctorsDrugsModalCtx>({
  openDoctorsDrugsModal: () => {},
});

// ─── Provider ─────────────────────────────────────────────────────────────────

export const DoctorsDrugsModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen]   = useState(false);
  const [tab,  setTab]    = useState<DoctorsDrugsTab>(0);

  const openDoctorsDrugsModal = useCallback((t: DoctorsDrugsTab = 0) => {
    setTab(t);
    setOpen(true);
  }, []);

  return (
    <Ctx.Provider value={{ openDoctorsDrugsModal }}>
      {children}
      <DoctorsDrugsModal
        open={open}
        initialTab={tab}
        onClose={() => setOpen(false)}
      />
    </Ctx.Provider>
  );
};

// ─── Hook ─────────────────────────────────────────────────────────────────────

export const useDoctorsDrugsModal = () => useContext(Ctx);
